export const environment = {
  production: false,
  env: 'SIT',
  apiUrl: 'https://channel-sit.chubblife.co.nz/newbusiness',
  oAuthBaseUrl: 'https://chubblife--aiotest.sandbox.my.salesforce.com',
  oAuthBaseUrlIFA: 'https://adviser-sit.chubblife.co.nz',
  oAuthClientId:
    '3MVG99S6MzYiT5k9MbbY.Hmhx3OUMpI4F5D5xRJ.ZEbzP_itLCwUNe7sODjKBf3pfRSWeAVZE2KK5PgKwLwP1', // gitleaks:allow
  oAuthCallBackUrl: 'https://adviserportal-sit.chubblife.co.nz/callback',
  appInsightsConnString:
    'InstrumentationKey=bb27a275-899d-4704-a3d5-215995ec9310;IngestionEndpoint=https://southeastasia-1.in.applicationinsights.azure.com/;LiveEndpoint=https://southeastasia.livediagnostics.monitor.azure.com/;ApplicationId=5167ff4b-bbd7-4e7b-9c38-356a0574671f', // gitleaks:allow
  instrumentationKey: 'bb27a275-899d-4704-a3d5-215995ec9310', // gitleaks:allow
  baseUrl: 'https://adviserportal-sit.chubblife.co.nz/',
  supportUrl: 'https://adviser-sit.chubblife.co.nz/s/contact-us',
  IAPolicyDetailsPage: 'https://chubblife--aiotest.sandbox.lightning.force.com/lightning/n/policy_details?c__policyNumber=',
  IFAPolicyDetailsPage: 'https://adviser-sit.chubblife.co.nz/s/policy-detail?policyNumber=',
};
